"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShoutAbilityHandler = exports.ShoutActorAbilityFactory = exports.ShoutAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ShoutAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Shout;
        this.__typeName = "Shout";
    }
}
exports.ShoutAbilityArgs = ShoutAbilityArgs;
let ShoutActorAbilityFactory = class ShoutActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Shout", "AllEnemies", 3);
    }
};
ShoutActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Shout")
], ShoutActorAbilityFactory);
exports.ShoutActorAbilityFactory = ShoutActorAbilityFactory;
let ShoutAbilityHandler = class ShoutAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyMultiAttack({
            sequence,
            abilityKey: "Shout",
            attackType: "magic",
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                targetId,
                jitter: 0,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Chaos", 120)
                ],
                effects: [
                    {
                        duration: Duration_1.Duration.Turns(1),
                        effect: new core_1.ConfusedEffectArgs,
                        targetId
                    }
                ]
            }))
        });
    }
};
ShoutAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Shout)
], ShoutAbilityHandler);
exports.ShoutAbilityHandler = ShoutAbilityHandler;
